/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { couponControllerConnect } from '../fn/coupon/coupon-controller-connect';
import { CouponControllerConnect$Params } from '../fn/coupon/coupon-controller-connect';
import { couponControllerCreate } from '../fn/coupon/coupon-controller-create';
import { CouponControllerCreate$Params } from '../fn/coupon/coupon-controller-create';
import { couponControllerDelete } from '../fn/coupon/coupon-controller-delete';
import { CouponControllerDelete$Params } from '../fn/coupon/coupon-controller-delete';
import { couponControllerDuplicate } from '../fn/coupon/coupon-controller-duplicate';
import { CouponControllerDuplicate$Params } from '../fn/coupon/coupon-controller-duplicate';
import { couponControllerFindById } from '../fn/coupon/coupon-controller-find-by-id';
import { CouponControllerFindById$Params } from '../fn/coupon/coupon-controller-find-by-id';
import { couponControllerReseed } from '../fn/coupon/coupon-controller-reseed';
import { CouponControllerReseed$Params } from '../fn/coupon/coupon-controller-reseed';
import { couponControllerSearchByAdmin } from '../fn/coupon/coupon-controller-search-by-admin';
import { CouponControllerSearchByAdmin$Params } from '../fn/coupon/coupon-controller-search-by-admin';
import { couponControllerSearchLog } from '../fn/coupon/coupon-controller-search-log';
import { CouponControllerSearchLog$Params } from '../fn/coupon/coupon-controller-search-log';
import { couponControllerStopToggle } from '../fn/coupon/coupon-controller-stop-toggle';
import { CouponControllerStopToggle$Params } from '../fn/coupon/coupon-controller-stop-toggle';
import { couponControllerUpdateTargets } from '../fn/coupon/coupon-controller-update-targets';
import { CouponControllerUpdateTargets$Params } from '../fn/coupon/coupon-controller-update-targets';
import { couponControllerUse } from '../fn/coupon/coupon-controller-use';
import { CouponControllerUse$Params } from '../fn/coupon/coupon-controller-use';
import { CouponCountDto } from '../models/coupon-count-dto';
import { CouponDto } from '../models/coupon-dto';
import { CouponSearchResponseDto } from '../models/coupon-search-response-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { parentCouponControllerConnect } from '../fn/coupon/parent-coupon-controller-connect';
import { ParentCouponControllerConnect$Params } from '../fn/coupon/parent-coupon-controller-connect';
import { parentCouponControllerFindById } from '../fn/coupon/parent-coupon-controller-find-by-id';
import { ParentCouponControllerFindById$Params } from '../fn/coupon/parent-coupon-controller-find-by-id';
import { parentCouponControllerGetCount } from '../fn/coupon/parent-coupon-controller-get-count';
import { ParentCouponControllerGetCount$Params } from '../fn/coupon/parent-coupon-controller-get-count';
import { parentCouponControllerSearch } from '../fn/coupon/parent-coupon-controller-search';
import { ParentCouponControllerSearch$Params } from '../fn/coupon/parent-coupon-controller-search';
import { parentCouponControllerUse } from '../fn/coupon/parent-coupon-controller-use';
import { ParentCouponControllerUse$Params } from '../fn/coupon/parent-coupon-controller-use';
import { teacherCouponControllerConnect } from '../fn/coupon/teacher-coupon-controller-connect';
import { TeacherCouponControllerConnect$Params } from '../fn/coupon/teacher-coupon-controller-connect';
import { teacherCouponControllerFindById } from '../fn/coupon/teacher-coupon-controller-find-by-id';
import { TeacherCouponControllerFindById$Params } from '../fn/coupon/teacher-coupon-controller-find-by-id';
import { teacherCouponControllerGetCount } from '../fn/coupon/teacher-coupon-controller-get-count';
import { TeacherCouponControllerGetCount$Params } from '../fn/coupon/teacher-coupon-controller-get-count';
import { teacherCouponControllerSearch } from '../fn/coupon/teacher-coupon-controller-search';
import { TeacherCouponControllerSearch$Params } from '../fn/coupon/teacher-coupon-controller-search';
import { teacherCouponControllerSearchAvailableCoupons } from '../fn/coupon/teacher-coupon-controller-search-available-coupons';
import { TeacherCouponControllerSearchAvailableCoupons$Params } from '../fn/coupon/teacher-coupon-controller-search-available-coupons';
import { teacherCouponControllerUse } from '../fn/coupon/teacher-coupon-controller-use';
import { TeacherCouponControllerUse$Params } from '../fn/coupon/teacher-coupon-controller-use';

@Injectable({ providedIn: 'root' })
export class CouponService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `couponControllerSearchByAdmin()` */
  static readonly CouponControllerSearchByAdminPath = '/api/coupon/admin';

  /**
   * Coupon 관리자 검색 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponControllerSearchByAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponControllerSearchByAdmin$Response(params: CouponControllerSearchByAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponSearchResponseDto>> {
    return couponControllerSearchByAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 관리자 검색 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponControllerSearchByAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponControllerSearchByAdmin(params: CouponControllerSearchByAdmin$Params, context?: HttpContext): Observable<CouponSearchResponseDto> {
    return this.couponControllerSearchByAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponSearchResponseDto>): CouponSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `couponControllerSearchLog()` */
  static readonly CouponControllerSearchLogPath = '/api/coupon/log';

  /**
   * 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponControllerSearchLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponControllerSearchLog$Response(params: CouponControllerSearchLog$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return couponControllerSearchLog(this.http, this.rootUrl, params, context);
  }

  /**
   * 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponControllerSearchLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponControllerSearchLog(params: CouponControllerSearchLog$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.couponControllerSearchLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `couponControllerFindById()` */
  static readonly CouponControllerFindByIdPath = '/api/coupon/{id}';

  /**
   * Coupon 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponControllerFindById$Response(params: CouponControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponDto>> {
    return couponControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponControllerFindById(params: CouponControllerFindById$Params, context?: HttpContext): Observable<CouponDto> {
    return this.couponControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponDto>): CouponDto => r.body)
    );
  }

  /** Path part for operation `couponControllerDelete()` */
  static readonly CouponControllerDeletePath = '/api/coupon/{id}';

  /**
   * Coupon 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponControllerDelete$Response(params: CouponControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return couponControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponControllerDelete(params: CouponControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.couponControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `couponControllerCreate()` */
  static readonly CouponControllerCreatePath = '/api/coupon';

  /**
   * Coupon 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerCreate$Response(params: CouponControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return couponControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerCreate(params: CouponControllerCreate$Params, context?: HttpContext): Observable<void> {
    return this.couponControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `couponControllerReseed()` */
  static readonly CouponControllerReseedPath = '/api/coupon/reseed';

  /**
   * 쿠폰 카테고리 강제 재시드 (관리자용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponControllerReseed()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerReseed$Response(params: CouponControllerReseed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return couponControllerReseed(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 카테고리 강제 재시드 (관리자용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponControllerReseed$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerReseed(params: CouponControllerReseed$Params, context?: HttpContext): Observable<void> {
    return this.couponControllerReseed$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `couponControllerDuplicate()` */
  static readonly CouponControllerDuplicatePath = '/api/coupon/duplicate';

  /**
   * Coupon 복제.
   *
   * 기존 쿠폰을 복제하여 새로운 쿠폰을 생성합니다. 복제에 사용된 원본 쿠폰은 발행이 중지됩니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponControllerDuplicate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerDuplicate$Response(params: CouponControllerDuplicate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return couponControllerDuplicate(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 복제.
   *
   * 기존 쿠폰을 복제하여 새로운 쿠폰을 생성합니다. 복제에 사용된 원본 쿠폰은 발행이 중지됩니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponControllerDuplicate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerDuplicate(params: CouponControllerDuplicate$Params, context?: HttpContext): Observable<void> {
    return this.couponControllerDuplicate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `couponControllerUpdateTargets()` */
  static readonly CouponControllerUpdateTargetsPath = '/api/coupon/update';

  /**
   * Coupon 수정.
   *
   * 발급 대상자를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponControllerUpdateTargets()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerUpdateTargets$Response(params: CouponControllerUpdateTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return couponControllerUpdateTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 수정.
   *
   * 발급 대상자를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponControllerUpdateTargets$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerUpdateTargets(params: CouponControllerUpdateTargets$Params, context?: HttpContext): Observable<void> {
    return this.couponControllerUpdateTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `couponControllerConnect()` */
  static readonly CouponControllerConnectPath = '/api/coupon/connect';

  /**
   * Coupon 연결.
   *
   * 사용자가 쿠폰 코드를 입력하여 쿠폰을 자신의 계정에 연결합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponControllerConnect()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerConnect$Response(params: CouponControllerConnect$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return couponControllerConnect(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 연결.
   *
   * 사용자가 쿠폰 코드를 입력하여 쿠폰을 자신의 계정에 연결합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponControllerConnect$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerConnect(params: CouponControllerConnect$Params, context?: HttpContext): Observable<void> {
    return this.couponControllerConnect$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `couponControllerUse()` */
  static readonly CouponControllerUsePath = '/api/coupon/use';

  /**
   * Coupon 사용.
   *
   * LP 검사 생성시 생성된 검사를 반환
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponControllerUse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerUse$Response(params: CouponControllerUse$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return couponControllerUse(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 사용.
   *
   * LP 검사 생성시 생성된 검사를 반환
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponControllerUse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  couponControllerUse(params: CouponControllerUse$Params, context?: HttpContext): Observable<void> {
    return this.couponControllerUse$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `couponControllerStopToggle()` */
  static readonly CouponControllerStopTogglePath = '/api/coupon/{id}/stop/toggle';

  /**
   * Coupon 발행 중지 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `couponControllerStopToggle()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponControllerStopToggle$Response(params: CouponControllerStopToggle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return couponControllerStopToggle(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 발행 중지 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `couponControllerStopToggle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  couponControllerStopToggle(params: CouponControllerStopToggle$Params, context?: HttpContext): Observable<void> {
    return this.couponControllerStopToggle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `teacherCouponControllerSearch()` */
  static readonly TeacherCouponControllerSearchPath = '/api/teacher-coupon';

  /**
   * Coupon 검색 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teacherCouponControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  teacherCouponControllerSearch$Response(params: TeacherCouponControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponSearchResponseDto>> {
    return teacherCouponControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 검색 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teacherCouponControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  teacherCouponControllerSearch(params: TeacherCouponControllerSearch$Params, context?: HttpContext): Observable<CouponSearchResponseDto> {
    return this.teacherCouponControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponSearchResponseDto>): CouponSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `teacherCouponControllerGetCount()` */
  static readonly TeacherCouponControllerGetCountPath = '/api/teacher-coupon/count';

  /**
   * 회원 또는 센터의 쿠폰 개수 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teacherCouponControllerGetCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  teacherCouponControllerGetCount$Response(params?: TeacherCouponControllerGetCount$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponCountDto>> {
    return teacherCouponControllerGetCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 또는 센터의 쿠폰 개수 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teacherCouponControllerGetCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  teacherCouponControllerGetCount(params?: TeacherCouponControllerGetCount$Params, context?: HttpContext): Observable<CouponCountDto> {
    return this.teacherCouponControllerGetCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponCountDto>): CouponCountDto => r.body)
    );
  }

  /** Path part for operation `teacherCouponControllerSearchAvailableCoupons()` */
  static readonly TeacherCouponControllerSearchAvailableCouponsPath = '/api/teacher-coupon/use-coupon-search';

  /**
   * 회원 또는 비회원이 결제 전 사용 가능한 쿠폰 목록을 검색 조회합니다.
   *
   * 회원 또는 비회원이 전체, 개인, 센터 단위로 사용 가능한 Coupons 검색.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teacherCouponControllerSearchAvailableCoupons()` instead.
   *
   * This method doesn't expect any request body.
   */
  teacherCouponControllerSearchAvailableCoupons$Response(params: TeacherCouponControllerSearchAvailableCoupons$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponSearchResponseDto>> {
    return teacherCouponControllerSearchAvailableCoupons(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 또는 비회원이 결제 전 사용 가능한 쿠폰 목록을 검색 조회합니다.
   *
   * 회원 또는 비회원이 전체, 개인, 센터 단위로 사용 가능한 Coupons 검색.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teacherCouponControllerSearchAvailableCoupons$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  teacherCouponControllerSearchAvailableCoupons(params: TeacherCouponControllerSearchAvailableCoupons$Params, context?: HttpContext): Observable<CouponSearchResponseDto> {
    return this.teacherCouponControllerSearchAvailableCoupons$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponSearchResponseDto>): CouponSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `teacherCouponControllerFindById()` */
  static readonly TeacherCouponControllerFindByIdPath = '/api/teacher-coupon/{id}';

  /**
   * Coupon 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teacherCouponControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  teacherCouponControllerFindById$Response(params: TeacherCouponControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponDto>> {
    return teacherCouponControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teacherCouponControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  teacherCouponControllerFindById(params: TeacherCouponControllerFindById$Params, context?: HttpContext): Observable<CouponDto> {
    return this.teacherCouponControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponDto>): CouponDto => r.body)
    );
  }

  /** Path part for operation `teacherCouponControllerConnect()` */
  static readonly TeacherCouponControllerConnectPath = '/api/teacher-coupon/connect';

  /**
   * Coupon 연결.
   *
   * 사용자가 쿠폰 코드를 입력하여 쿠폰을 자신의 계정에 연결합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teacherCouponControllerConnect()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  teacherCouponControllerConnect$Response(params: TeacherCouponControllerConnect$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return teacherCouponControllerConnect(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 연결.
   *
   * 사용자가 쿠폰 코드를 입력하여 쿠폰을 자신의 계정에 연결합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teacherCouponControllerConnect$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  teacherCouponControllerConnect(params: TeacherCouponControllerConnect$Params, context?: HttpContext): Observable<void> {
    return this.teacherCouponControllerConnect$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `teacherCouponControllerUse()` */
  static readonly TeacherCouponControllerUsePath = '/api/teacher-coupon/use';

  /**
   * Coupon 사용.
   *
   * LP 검사 생성시 생성된 검사를 반환
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teacherCouponControllerUse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  teacherCouponControllerUse$Response(params: TeacherCouponControllerUse$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return teacherCouponControllerUse(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 사용.
   *
   * LP 검사 생성시 생성된 검사를 반환
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teacherCouponControllerUse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  teacherCouponControllerUse(params: TeacherCouponControllerUse$Params, context?: HttpContext): Observable<void> {
    return this.teacherCouponControllerUse$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `parentCouponControllerSearch()` */
  static readonly ParentCouponControllerSearchPath = '/api/parent-coupon';

  /**
   * Coupon 검색 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parentCouponControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCouponControllerSearch$Response(params: ParentCouponControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponSearchResponseDto>> {
    return parentCouponControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 검색 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `parentCouponControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCouponControllerSearch(params: ParentCouponControllerSearch$Params, context?: HttpContext): Observable<CouponSearchResponseDto> {
    return this.parentCouponControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponSearchResponseDto>): CouponSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `parentCouponControllerGetCount()` */
  static readonly ParentCouponControllerGetCountPath = '/api/parent-coupon/count';

  /**
   * 회원 또는 센터의 쿠폰 개수 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parentCouponControllerGetCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCouponControllerGetCount$Response(params?: ParentCouponControllerGetCount$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponCountDto>> {
    return parentCouponControllerGetCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 또는 센터의 쿠폰 개수 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `parentCouponControllerGetCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCouponControllerGetCount(params?: ParentCouponControllerGetCount$Params, context?: HttpContext): Observable<CouponCountDto> {
    return this.parentCouponControllerGetCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponCountDto>): CouponCountDto => r.body)
    );
  }

  /** Path part for operation `parentCouponControllerFindById()` */
  static readonly ParentCouponControllerFindByIdPath = '/api/parent-coupon/{id}';

  /**
   * Coupon 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parentCouponControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCouponControllerFindById$Response(params: ParentCouponControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponDto>> {
    return parentCouponControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `parentCouponControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentCouponControllerFindById(params: ParentCouponControllerFindById$Params, context?: HttpContext): Observable<CouponDto> {
    return this.parentCouponControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponDto>): CouponDto => r.body)
    );
  }

  /** Path part for operation `parentCouponControllerConnect()` */
  static readonly ParentCouponControllerConnectPath = '/api/parent-coupon/connect';

  /**
   * Coupon 연결.
   *
   * 사용자가 쿠폰 코드를 입력하여 쿠폰을 자신의 계정에 연결합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parentCouponControllerConnect()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parentCouponControllerConnect$Response(params: ParentCouponControllerConnect$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return parentCouponControllerConnect(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 연결.
   *
   * 사용자가 쿠폰 코드를 입력하여 쿠폰을 자신의 계정에 연결합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `parentCouponControllerConnect$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parentCouponControllerConnect(params: ParentCouponControllerConnect$Params, context?: HttpContext): Observable<void> {
    return this.parentCouponControllerConnect$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `parentCouponControllerUse()` */
  static readonly ParentCouponControllerUsePath = '/api/parent-coupon/use';

  /**
   * Coupon 사용.
   *
   * LP 검사 생성시 생성된 검사를 반환
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parentCouponControllerUse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parentCouponControllerUse$Response(params: ParentCouponControllerUse$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return parentCouponControllerUse(this.http, this.rootUrl, params, context);
  }

  /**
   * Coupon 사용.
   *
   * LP 검사 생성시 생성된 검사를 반환
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `parentCouponControllerUse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parentCouponControllerUse(params: ParentCouponControllerUse$Params, context?: HttpContext): Observable<void> {
    return this.parentCouponControllerUse$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
